import React from 'react';

export const webServerIcons = {
  'IIS': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0078D7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18"/><circle cx="7" cy="16" r="1"/><circle cx="17" cy="16" r="1"/></svg>
  ),
  'Nginx': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#009639" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12,2 22,7 22,17 12,22 2,17 2,7"/><text x="7" y="16" fontSize="7" fill="#009639">N</text></svg>
  ),
  'Apache': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#D22128" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 20l8-16 8 16"/><line x1="4" y1="20" x2="20" y2="20"/></svg>
  ),
  'LiteSpeed': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#00AEEF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12,2 22,12 12,22 2,12"/><line x1="12" y1="2" x2="12" y2="22"/></svg>
  ),
  'Tomcat': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F8C300" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="12" rx="10" ry="6"/><circle cx="12" cy="12" r="2"/></svg>
  ),
};

export function getWebServerIcon(name) {
  const key = Object.keys(webServerIcons).find(k => name.toLowerCase().includes(k.toLowerCase()));
  return webServerIcons[key] || null;
}
